export default "__VITE_ASSET__DO1QrvuQ__"